import { graphql } from "@/gql";

export const addIncidentPhotosMutation = graphql(`
  mutation AddIncidentPhotos($id: ID!, $filePaths: [String!]!) {
    addIncidentPhotos(id: $id, filePaths: $filePaths) {
      id
    }
  }
`);
